module.exports = __webpack_public_path__ + "static/media/icon-eye-white.f6e7ab66.svg";